<template>
    <div style="padding-bottom: 40px">
        <M3Warn v-if="data && data.m3_project && data.m3_project.duplicate_sections && data.m3_project.duplicate_sections.includes('financial_request')" type="yellow" :text="'Această secțiune a fost duplicată din proiectul companiei ' + getCompanyName(data.m3_project.duplicate_company_id)"></M3Warn>
        <CFTitle title="10. Justificare"></CFTitle>
        <validation-observer #default="{ invalid }" ref="justificare">
            <span class="display-none">{{ invalid }}</span>
            <M3Warn type="yellow" text="În vederea justificării proiectului, se vor prezenta următoarele elemente:<ul><li>modalitatea în care finanțarea acordată ajută la dezvoltarea de noi activități, precum și contribuția acestora la crearea de valoare adăugată din punct de vedere economic</li><li>principalele nevoi/necesități/probleme care justifică intervențiile </li></ul>Se va prezenta gradul de noutate al produsului/procesului în comparație cu produsele/ procesele existente pe piață la momentul propunerii; impactul implementării proiectului și necesitatea privind obținerea ajutorului nerambursabil; măsura în care rezultatele preconizate a se obține prin implementarea proiectului vor avea piață de desfacere și sunt prezentate beneficiile și avantajele acestora comparativ cu concurența, îmbunătățire/creșterea nivelului tehnologic al întreprinderii solicitante prin achiziționarea de active corporale/necorporale care să sprijine procesul tehnologic comparativ cu tehnologiile existente înaintea demarării proiectului, avantajele și beneficiile fluxului tehnologic inovativ comparativ cu cel existent în întreprindere la momentul solicitării finanțării nerambursabile etc." ></M3Warn>
            <validation-provider
                #default="{ errors }"
                rules="required"
            >
                <CFTextarea v-model="form.justificare" :read-only="completed" :limit="10500"></CFTextarea>
                <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <hr class="mt-4">
        </validation-observer>
        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle"
    import CFTextarea from "./CFTextarea";
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import M3Warn from '@/pages/Aplicatii/M3/M3Sketch/components/M3Warn'
    import { BFormInput, BFormGroup, BFormCheckbox, BIconInfoCircleFill, BTooltip } from "bootstrap-vue";
    import { ValidationProvider, ValidationObserver } from 'vee-validate';


    export default {
        name: "CFJustificare",
        components:{
            CFTitle,
            CFTextarea,
            M3Warn,
            BFormInput, BFormGroup, BFormCheckbox, BIconInfoCircleFill, BTooltip,
            ValidationProvider,
            ValidationObserver,
        },
        props:{
            m3GrantApplication: {
                type: Object,
                default: null
            },
            data: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                completed: null,
                form: {
                    justificare: '',
                }
            }
        },
        computed: {
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
            finantareProgress() {
                return this.$store.getters['finantare/progress']
            }
        },
        watch: {
            finantareProgress: {
                handler: function() {
                    if(this.finantareProgress && this.finantareProgress.includes('Justificare')) {
                        this.completed = true
                    }
                },
                deep: true
            },
            m3GrantApplication: {
                handler () {
                    if(this.m3GrantApplication && this.m3GrantApplication.justificare){
                        this.form.justificare= this.m3GrantApplication.justificare.justificare;
                    }
                },
                deep: true
            }
        },
        mounted() {
            if(this.m3GrantApplication && this.m3GrantApplication.justificare){
                this.form.justificare= this.m3GrantApplication.justificare.justificare;
            } else {
                this.form.justificare = 'Produsul/serviciul nou propus în cadrul proiectului de către '+ JSON.parse(localStorage.getItem('currentM3Company')).name +' este _________. Comparativ cu produsele/procesele existente pe piață, elementul de noutate îl constituie __________. Achiziționarea de echipamente _________ și software __________ va contribui la îmbunătățirea procesului tehnologic astfel: _________________. Comparativ cu tehnologia utilizată în prezent: _____________ (descriere tehnologie existentă), fluxul tehnologic propus are următoarele avantaje: _____________________. '
            }
            if(this.finantareProgress && this.finantareProgress.includes('Justificare')) {
                this.completed = true
            }
        },
        methods:{
            getCompanyName(id){
                let name = '';
                this.companies.forEach(company => {
                    if(Number(company.id) === Number(id))
                        name = company.name
                })

                return name;
            },
            sendForm(){
                if(this.completed){
                    this.$refs.justificare.validate().then((e) => {
                        if (!e) {
                            this.completed = false
                            this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        } else {
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {justificare: this.form})
                                .then( () => {
                                    this.$toast.success('Informațiile au fost salvate!')
                                    this.$emit('savedData')
                                    this.$store.dispatch('finantare/addToProgress', 'Justificare')
                                })
                        }
                    })
                }
                else{
                    this.$store.dispatch('finantare/removeFromProgress', 'Justificare')
                }
            }
        }
    }
</script>

<style scoped>
div >>> ul{
  list-style: inside;
}
</style>
